import React from "react";
import "./../../styles/components/Solutions.css";
import CurrentTheme from "./../CurrentTheme";

export default function SolutionsEN() {
  return (
    <div className="solutions">
      <div className="bens-container">
        <div className="solutions-top">
          <div className="box-col">
            <div className="media-group has-one">
              <a
                className="media-item"
                href="https://bens-digital-change.com/achat-et-vente-a-linternational"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>International Buying / Selling</h4>
                <img
                  src="/img/sol-04.webp"
                  alt="Sol 04"
                  loading="lazy"
                  width={351}
                  height={363}
                />
              </a>

              <a
                className="media-item"
                href="https://bens-digital-change.com/payez-vos-fournisseurs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>Supplier payment</h4>
                <img
                  src="/img/sol-03.webp"
                  alt="Sol 03"
                  loading="lazy"
                  width={358}
                  height={351}
                />
              </a>
            </div>
          </div>
          <div className="box-col solutions-top-right">
            <h2>The exchange solution adapted to your professional needs</h2>
            <a
              href="https://bens-digital-change.swiss/register"
              target="_blank"
              rel="noopener noreferrer"
            >
              Free and non-binding registration
            </a>
            <a
              href="https://calendly.com/bens_digital/demande-d-assistance"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact our advisers
            </a>
          </div>
        </div>

        <div className="section-08-box solutions-bottom">
          <div className="box-col">
            <img
              src="https://bens-digital-change.com/images/v2/get-mobile-back.webp"
              alt="Get Mobile"
              className="box-img"
              loading="lazy"
              width={733}
              height={671}
            />
          </div>
          <div className="box-col">
            <h2 className="box-title">Our solution is available on mobile</h2>
            <img
              src="/img/bens-title-dark.svg"
              alt="Bens"
              className="box-desc-img"
              loading="lazy"
              width={399}
              height={51}
            />
            <p className="box-long-desc">
              Carry out all your foreign exchange transactions on our
              application available on Android and IOS. Do you want to change
              your currency at a specific time?
            </p>
            <p className="box-long-desc">
              Our application offers you the possibility to create an alert to
              notify you when the exchange rate reaches the one you you desire.
            </p>
            <a
              href="https://bens-digital-change.ch/download-mobile-app"
              className="box-store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://bens-digital-change.com/images/v2/bens-stores.webp"
                alt="Bens Store"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        className="solutions-back"
        style={{
          background:
            "linear-gradient(180deg, " +
            CurrentTheme(process.env.REACT_APP_THEME)["color"][0] +
            " 0%, " +
            CurrentTheme(process.env.REACT_APP_THEME)["color"][1] +
            " 100%)",
        }}
      ></div>
    </div>
  );
}
